import React from 'react';
import clsx from 'clsx';
import AlertCircleIcon from 'components/ui/Icon/icons/AlertCircleIcon';
import BuildingIcon from 'components/ui/Icon/icons/BuildingIcon';
import CalendarIcon from 'components/ui/Icon/icons/CalendarIcon';
import CheckCircleIcon from 'components/ui/Icon/icons/CheckCircleIcon';
import ChevronDownIcon from 'components/ui/Icon/icons/ChevronDownIcon';
import ChevronRightIcon from 'components/ui/Icon/icons/ChevronRightIcon';
import ExternalLinkIcon from 'components/ui/Icon/icons/ExternalLinkIcon';
import LogOutIcon from 'components/ui/Icon/icons/LogOutIcon';
import MenuIcon from 'components/ui/Icon/icons/MenuIcon';
import SearchIcon from 'components/ui/Icon/icons/SearchIcon';
import UserIcon from 'components/ui/Icon/icons/UserIcon';
import XIcon from 'components/ui/Icon/icons/XIcon';
import styles from './Icon.module.scss';

export type IconName =
  | 'user'
  | 'building'
  | 'log-out'
  | 'chevron-right'
  | 'chevron-down'
  | 'search'
  | 'menu'
  | 'x'
  | 'calendar'
  | 'external-link'
  | 'check-circle'
  | 'alert-circle';

const ICONS: Record<IconName, React.ComponentType> = {
  user: UserIcon,
  building: BuildingIcon,
  'log-out': LogOutIcon,
  'chevron-right': ChevronRightIcon,
  'chevron-down': ChevronDownIcon,
  search: SearchIcon,
  menu: MenuIcon,
  x: XIcon,
  calendar: CalendarIcon,
  'external-link': ExternalLinkIcon,
  'check-circle': CheckCircleIcon,
  'alert-circle': AlertCircleIcon,
};

export interface IIconProps {
  name: IconName;
  size?: number;
  className?: string;
  'aria-hidden'?: boolean | 'true' | 'false';
  'aria-label'?: string;
}

export default function Icon({
  name,
  size = 20,
  className,
  'aria-hidden': ariaHidden = true,
  'aria-label': ariaLabel,
}: IIconProps) {
  const Glyph = ICONS[name];

  return (
    <svg
      className={clsx(styles.icon, className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      focusable="false"
    >
      <Glyph />
    </svg>
  );
}
